// extracted by mini-css-extract-plugin
export default {"container":"-z840","title":"Dcdhs","location":"iGuls","noLocation":"hpaUR","listHeaderLocation":"rvtCE"};